import supportMaterial from '../../assets/support-material.svg';
export const helpActions = [
  {
    image: supportMaterial,
    alt: 'Imagem remetendo à uma tela com esboços de gráficos e notas',
    title: 'Material de apoio para desenvolvedores',
    description:
      'Confira nossa documentação com tudo que precisa para começar a desenvolver sua aplicação usando nossa API de maneira simples',
    link: 'https://developers.arquivei.com.br/docs',
    backgroundColor: 'primary.solidBg',
    linkText: 'VER DOCUMENTAÇÃO',
  },
];
